import { render, staticRenderFns } from "./EntityRequestsTable.vue?vue&type=template&id=3db47fd5"
import script from "./EntityRequestsTable.vue?vue&type=script&lang=js"
export * from "./EntityRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports